import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const popupsLayout = ({ children, noNavbar, noFooter }) => (
  <Container fluid className="h-100">
    <ToastContainer />
    <Row className="h-100 p-5">
      <Col
        className="main-content p-0"
        lg={{ size: 12 }}
        md={{ size: 12 }}
        sm="12"
        tag="main"
      >
        {children}
      </Col>
    </Row>
  </Container>
);

popupsLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

popupsLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default popupsLayout;
